import tarotReadingsVi from "./tarot/languages/tarot-readings-en.json";

export const en = {
  // Brand
  brandName: "TAROTO",

  // Navigation
  backHome: "Back Home",
  chooseDifferentCategory: "Choose Different Category",

  // Home Page
  homeDescription:
    "Discover the wisdom of the cards through modern digital divination",
  cardOfTheDay: "Card of the Day",
  demoPage: "Demo Page",

  // COTD Page
  cotdTitle: "Card of the Day",
  cotdDescription: "Choose a category to focus your daily card reading",

  // Categories
  categoryLove: "Love",
  categoryWork: "Work",
  categoryFriends: "Friends",
  categoryLoveDesc:
    "Insights into relationships, romance, and matters of the heart",
  categoryWorkDesc: "Guidance on career, projects, and professional challenges",
  categoryFriendsDesc:
    "Understanding friendships, social connections, and community",

  // COTD Session
  focusLabel: "Focus:",
  drawPrompt: "Draw your {category} card to discover today's guidance",
  drawPromptGeneral: "Draw your card to discover today's guidance",
  drawCard: "Draw Card",
  drawNewCard: "Draw New Card",

  // Card Guidance
  guidanceLove:
    "Consider how this card's energy influences your relationships and romantic connections today.",
  guidanceWork:
    "Reflect on how this card's wisdom can guide your professional decisions and career path.",
  guidanceFriends:
    "Think about how this card relates to your friendships and social interactions today.",
  guidanceGeneral:
    "Reflect on how this card's energy might guide your day ahead.",

  // Demo Page
  demoTitle: "Demo / Development",
  componentShowcase: "Component Showcase",
  buttonsSection: "Buttons",
  typographySection: "Typography",
  cardSection: "Card Placeholder",
  layoutSection: "Layout Example",
  outlineButton: "Outline",
  filledButton: "Filled",
  heading2: "Heading 2",
  bodyText: "Body Text",
  secondaryText: "Secondary Text",

  readings: tarotReadingsVi,

  // Tarot Cards
  cards: {
    // Major Arcana
    "The Fool": "New beginnings, spontaneity, innocence",
    "The Magician": "Manifestation, resourcefulness, power",
    "The High Priestess": "Intuition, sacred knowledge, divine feminine",
    "The Empress": "Femininity, beauty, nature, abundance",
    "The Emperor": "Authority, establishment, structure, father figure",
    "The Hierophant": "Spiritual wisdom, religious beliefs, conformity",
    "The Lovers": "Love, harmony, relationships, values alignment",
    "The Chariot": "Control, willpower, success, determination",
    Strength: "Strength, courage, persuasion, influence",
    "The Hermit": "Soul searching, introspection, inner guidance",
    "Wheel of Fortune": "Good luck, karma, life cycles, destiny",
    Justice: "Justice, fairness, truth, cause and effect",
    "The Hanged Man": "Suspension, restriction, letting go, sacrifice",
    Death: "Endings, beginnings, change, transformation",
    Temperance: "Balance, moderation, patience, purpose",
    "The Devil": "Bondage, addiction, sexuality, materialism",
    "The Tower": "Sudden change, upheaval, chaos, revelation",
    "The Star": "Hope, faith, purpose, renewal, spirituality",
    "The Moon": "Illusion, fear, anxiety, subconscious, intuition",
    "The Sun": "Positivity, fun, warmth, success, vitality",
    Judgement: "Judgement, rebirth, inner calling, absolution",
    "The World": "Completion, accomplishment, travel, fulfillment",

    // Cups
    "Ace of Cups": "Love, intuition, spiritual connection, new emotions",
    "Two of Cups": "Unified love, partnership, mutual attraction",
    "Three of Cups": "Celebration, friendship, creativity, community",
    "Four of Cups": "Meditation, contemplation, apathy, reevaluation",
    "Five of Cups": "Loss, regret, disappointment, pessimism",
    "Six of Cups": "Revisiting the past, childhood memories, innocence",
    "Seven of Cups": "Opportunities, choices, wishful thinking, illusion",
    "Eight of Cups": "Disappointment, abandonment, withdrawal, escapism",
    "Nine of Cups": "Contentment, satisfaction, gratitude, wish fulfillment",
    "Ten of Cups": "Divine love, blissful relationships, harmony, alignment",
    "Page of Cups": "Creative opportunities, intuitive messages, curiosity",
    "Knight of Cups": "Creativity, romance, charm, imagination",
    "Queen of Cups": "Compassionate, caring, emotionally stable, intuitive",
    "King of Cups": "Emotionally balanced, compassionate, generous",

    // Pentacles
    "Ace of Pentacles": "A new financial or career opportunity, manifestation",
    "Two of Pentacles": "Multiple priorities, time management, prioritization",
    "Three of Pentacles": "Teamwork, collaboration, learning, implementation",
    "Four of Pentacles": "Saving money, security, conservatism, scarcity",
    "Five of Pentacles": "Financial loss, poverty, lack mindset, isolation",
    "Six of Pentacles": "Giving, receiving, sharing wealth, generosity",
    "Seven of Pentacles": "Long-term view, sustainable results, perseverance",
    "Eight of Pentacles":
      "Apprenticeship, repetitive tasks, mastery, skill development",
    "Nine of Pentacles":
      "Abundance, luxury, self-reliance, financial independence",
    "Ten of Pentacles": "Wealth, financial security, family, long-term success",
    "Page of Pentacles":
      "Manifestation, financial opportunity, skill development",
    "Knight of Pentacles": "Hard work, productivity, routine, conservatism",
    "Queen of Pentacles":
      "Nurturing, practical, providing financially, down-to-earth",
    "King of Pentacles":
      "Financial success, business acumen, security, abundance",

    // Swords
    "Ace of Swords":
      "New ideas, mental clarity, breakthrough, intellectual power",
    "Two of Swords":
      "Difficult decisions, weighing options, indecision, blocked emotions",
    "Three of Swords": "Heartbreak, emotional pain, sorrow, grief, betrayal",
    "Four of Swords":
      "Rest, relaxation, meditation, contemplation, recuperation",
    "Five of Swords":
      "Conflict, disagreements, competition, defeat, winning at all costs",
    "Six of Swords": "Transition, change, rite of passage, releasing baggage",
    "Seven of Swords":
      "Betrayal, deception, getting away with something, strategic withdrawal",
    "Eight of Swords":
      "Negative thoughts, self-imposed restriction, imprisonment, victim mentality",
    "Nine of Swords": "Anxiety, worry, fear, depression, nightmares",
    "Ten of Swords": "Painful endings, deep wounds, betrayal, loss, crisis",
    "Page of Swords":
      "New ideas, curiosity, thirst for knowledge, new ways of communicating",
    "Knight of Swords":
      "Ambitious, action-oriented, driven to succeed, fast-thinking",
    "Queen of Swords":
      "Independent, unbiased judgement, clear boundaries, direct communication",
    "King of Swords": "Mental clarity, intellectual power, authority, truth",

    // Wands
    "Ace of Wands": "Inspiration, new opportunities, growth, potential",
    "Two of Wands": "Future planning, making decisions, leaving comfort zone",
    "Three of Wands":
      "Expansion, foresight, overseas opportunities, leadership",
    "Four of Wands": "Celebration, joy, harmony, relaxation, homecoming",
    "Five of Wands": "Conflict, disagreements, competition, tension, diversity",
    "Six of Wands": "Success, public recognition, progress, self-confidence",
    "Seven of Wands": "Challenge, competition, protection, perseverance",
    "Eight of Wands":
      "Movement, fast paced change, action, alignment, air travel",
    "Nine of Wands":
      "Resilience, courage, persistence, test of faith, boundaries",
    "Ten of Wands": "Burden, extra responsibility, hard work, completion",
    "Page of Wands":
      "Inspiration, ideas, discovery, limitless potential, free spirit",
    "Knight of Wands":
      "Energy, passion, inspired action, adventure, impulsiveness",
    "Queen of Wands":
      "Courage, confidence, independence, social butterfly, determination",
    "King of Wands": "Natural leader, vision, entrepreneur, honour, boldness",
  },
};
